import * as tocbot from 'tocbot';
if (document.getElementsByClassName('toc').length) {
    tocbot.init({
        tocSelector: '.toc',
        contentSelector: '.post-content',
        headingSelector: 'h2,h3',
        extraLinkClasses: 'text-sm hover:text-fiord-500 transition duration-300 ease-in-and-out block',
        // For some weird-ass reason the class is emitted if the class name is present in `extraLinkClasses`
        // which is why we can't just use `text-fiord-500` here.
        activeLinkClass: 'toc-active-link',
        scrollSmooth: true,
        scrollSmoothDuration: 500,
        headingsOffset: 80,
        scrollSmoothOffset: -80
    });
}
